import { useEffect, useState } from "react"

// After the account box: the server lands a resumed action on a page marked
// `?resume=<action>` (ViewingRoom::Resume.marked), or `unavailable`. The mark
// is read once and taken out of the address, so a reload or a shared link does
// not repeat it. Pages show the approved line only when their own state agrees
// (a saved freelancer shows as saved), never from the mark alone.
export function useResumed() {
  const [resumed] = useState(() => new URLSearchParams(window.location.search).get("resume"))

  useEffect(() => {
    if (!resumed) return
    const url = new URL(window.location.href)
    url.searchParams.delete("resume")
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash)
  }, [resumed])

  return resumed
}

export default function ResumedNotice({ children }) {
  return (
    <div role="status" className="mx-[26px] mt-[18px] rounded-[12px] border border-border bg-secondary px-[16px] py-[12px] text-[13.5px] text-foreground max-[861px]:mx-[14px]">
      {children}
    </div>
  )
}
